export const PROMISIFY_WATCHER_PREFIX = `@@PROMISIFY_ACTION`;
export const START_WATCH_PROMISIFIED_ACTION = `${PROMISIFY_WATCHER_PREFIX}/START_WATCH`;
export const STOP_WATCH_PROMISIFIED_ACTION = `${PROMISIFY_WATCHER_PREFIX}/STOP_WATCH`;
